module.exports = __webpack_public_path__ + "static/media/8.jpg.53073a89.webp";